import { render } from "./RAndP.vue?vue&type=template&id=7904ec92&scoped=true"
import script from "./RAndP.vue?vue&type=script&lang=js"
export * from "./RAndP.vue?vue&type=script&lang=js"

import "./RAndP.vue?vue&type=style&index=0&id=7904ec92&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7904ec92"]])

export default __exports__